const STORAGE_KEY = 'onboarding_individualSubscriptionInvitationId';

export function readStoredIndividualSubscriptionInvitationId(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function writeStoredIndividualSubscriptionInvitationId(value: string | null) {
  try {
    if (value === null) sessionStorage.removeItem(STORAGE_KEY);
    else sessionStorage.setItem(STORAGE_KEY, value);
  } catch {
    // Storage can be unavailable; the in-memory store still supports the current page.
  }
}
